// src/utils/authUtils.ts
import { signOut } from "aws-amplify/auth";
import { clearUserData, setUserLoggedOut } from "../redux/authSlice.ts";
import { clearUserDetails } from "../redux/userSlice.ts";
import { Dispatch } from "redux";

/**
 * Handles user sign-out process
 * @param dispatch Redux dispatch function
 * @param navigateCallback Optional navigation callback function
 */
export const handleSignOut = async (
  dispatch: Dispatch,
  navigateCallback?: (path: string) => void
) => {
  try {
    // Perform Amplify sign out
    await signOut();

    // Clear Redux state
    dispatch(clearUserData());
    dispatch(clearUserDetails());
    dispatch(setUserLoggedOut());

    // Clear local storage
    localStorage.removeItem("sessionStartTime");

    // Navigate to home if callback provided
    if (navigateCallback) {
      navigateCallback("/");
    }
  } catch (error) {
    console.error("Error during sign out:", error);
    throw error;
  }
};

/**
 * Utility function to check and handle session expiry
 */
export const checkSessionExpiry = () => {
  const sessionStartTime = localStorage.getItem("sessionStartTime");
  if (sessionStartTime) {
    const currentTime = new Date().getTime();
    const sessionDuration = currentTime - parseInt(sessionStartTime);
    const sessionTimeout = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    return sessionDuration > sessionTimeout;
  }
  return false;
};
